// Página da ficha cadastral do merchant (superAdmin).
//
// NÃO recebe uuid pela rota nem tem listagem: o merchant é o do usuário logado
// (`authData.user.merchantId`, que é o uuid STO- da store). Pedir para o
// operador procurar a própria loja seria escolher algo que o login já resolveu.
import { useTranslation } from "react-i18next"

import { AppBreadcrumb } from "@/components/layout/app-breadcrumb"
import { Header } from "@/components/layout/header"
import { FRONTEND_ROUTES } from "@/constants"
import { useAuth } from "@/contexts/auth"
import { MerchantDetail } from "@/features/merchant-admin"

export function MerchantDetailPage() {
  const { t } = useTranslation()
  const { authData } = useAuth()
  const merchantId = authData?.user?.merchantId ?? ""

  return (
    <main className="flex w-full flex-1 flex-col">
      <Header>
        <AppBreadcrumb
          links={[
            {
              href: FRONTEND_ROUTES.DASHBOARD.href,
              label: t("sidebar.dashboard"),
            },
            {
              label: t("sidebar.administration"),
            },
            {
              label: t("sidebar.merchant"),
            },
          ]}
        />
      </Header>
      <section className="flex flex-1 flex-col gap-4 overflow-x-hidden p-4 @container">
        <div className="flex flex-col gap-1">
          <h1 className="page-title">
            {t("pages.adminMerchants.title")}
          </h1>
          <p className="text-sm text-muted-foreground">
            {t("pages.adminMerchants.subtitle")}
          </p>
        </div>

        {merchantId ? (
          <MerchantDetail uuid={merchantId} />
        ) : (
          // Sem merchant no token não há o que mostrar — e chamar a API com
          // uuid vazio devolveria 404 sem explicar o motivo real ao operador.
          <div
            data-testid="merchant-missing-session"
            className="flex flex-col items-center gap-2 rounded-xl border border-dashed px-6 py-14 text-center"
          >
            <p className="text-sm text-muted-foreground">
              {t("pages.adminMerchants.missingSession")}
            </p>
          </div>
        )}
      </section>
    </main>
  )
}
